// Saved compositions for Jianpu Studio — plain localStorage, one entry per
// song. No cloud, no accounts: these live on the device, and export/import
// of the text files covers moving them around.

const KEY = "jianpu-studio:songs:v1";

function readAll() {
  if (typeof window === "undefined" || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    // Storage full or blocked — saving is best-effort.
  }
}

export function listSavedSongs() {
  return readAll().sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
}

export function getSavedSong(id) {
  return readAll().find((s) => s.id === id) || null;
}

// Save (or overwrite by id) and return the entry.
export function saveSong({ id, title, text }) {
  const list = readAll();
  const entry = {
    id: id || `song-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`,
    title: title || "Untitled",
    text: text || "",
    updatedAt: Date.now(),
  };
  const idx = list.findIndex((s) => s.id === entry.id);
  if (idx >= 0) list[idx] = entry;
  else list.push(entry);
  writeAll(list);
  return entry;
}

export function deleteSong(id) {
  writeAll(readAll().filter((s) => s.id !== id));
}
